import React from 'react';
import { findDOMNode, unmountComponentAtNode } from 'react-dom';
import ResetForm from './ResetForm';
import ConfirmForm from './ConfirmForm';
import InactiveBg from '../components/InactiveBg';
import axios from 'axios';

export default class CampaignCreator extends React.Component {
  state = {
    resetPasswordWasSent: false
  };

  resetPassword = (e, formData) => {
    e.preventDefault();

    formData.action = 'reset-password';
    document.getElementById('loading').style.display = "block";
    axios.post('/p2p/reset-hesla/', formData).then((response) => {
      const { initProps: { redirectTo } = {} } = this.props;

      if (redirectTo) {
        window.location.href = redirectTo;
      } else {
        this.setState({
          resetPasswordWasSent: true
        });
      }
      document.getElementById('loading').style.display = "none";
    }).catch((error) => {
      document.getElementById('loading').style.display = "none";
      app.features.notification('.js-notification', {
        text: 'Nepodarilo sa zaslať vám inštrukcie k obnove hesla',
        status: 'error'
      });
    });
  };

  confirmNewPassword = (e, formData) => {
    const { initProps: { redirectTo, token } = {} } = this.props;

    let url = '/p2p/reset-hesla/' + token + "/";
    document.getElementById('loading').style.display = "block";
    axios.post(url, formData).then((response) => {
      this.setState({
        resetPasswordWasSent: true
      });
      document.getElementById('loading').style.display = "none";
    }).catch((error) => {
      document.getElementById('loading').style.display = "none";
      app.features.notification('.js-notification', {
        text: 'Nepodarilo sa nastaviť vám nové heslo',
        status: 'error'
      });
    });
  };

  onCancel = () => {
    // eslint-disable-next-line react/no-find-dom-node
    const thisNode = findDOMNode(this);
    unmountComponentAtNode(thisNode.parentNode);
  };

  render() {
    const { initProps: { confirmEmail, token, asPage } = {} } = this.props;
    const { resetPasswordWasSent } = this.state;

    const childrenForm = (confirmEmail && token)
      ? <ConfirmForm onSubmit={this.confirmNewPassword} langSwitcher={asPage} uuid={token} wasSent={resetPasswordWasSent} />
      : <ResetForm onSubmit={this.resetPassword} langSwitcher={asPage} wasSent={resetPasswordWasSent} />;

    return asPage
      ? childrenForm
      : <InactiveBg onClose={this.onCancel}>
          <div style={{ position: 'relative', top: '4rem' }}>
            {childrenForm}
          </div>
        </InactiveBg>;
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/passwordReset/index.js